<template>
    <div>
        <!-- ##### Breadcumb Area Start ##### -->
        <section class="breadcumb-area bg-img d-flex align-items-center justify-content-center" style="background-image: url(images/landing_reviews.jpeg);">
            <!-- <div class="bradcumbContent">
                <h2>Reviews</h2>
            </div> -->
        </section>
        <!-- ##### Breadcumb Area End ##### -->

        <!-- ##### Reviews Area Start ##### -->
        <div class="reviews-area mt-5 section-padding-0-100" id="reviews">
            <div class="container">
                <div class="row  justify-content-md-center">
                    <div class="col-12 col-md-8 " v-for="review in reviewList">
                        <div class="card mb-3">
                            <div class="card-body review-card">
                                <div class="d-flex">
                                    <div class="w-100">
                                        <span class="h4 text-info">{{review.ReviewerName}}</span>
                                    </div>
                                    <div class="flex-shrink-1">
                                        <img  class="img-fluid" :src="review.ReviewSource == 'Trip Advisor' ? require('@/assets/img/core-img/trip.png') : review.ReviewSource == 'Booking.com' ? require('@/assets/img/core-img/booking.png') : review.ReviewSource == 'Expedia' ? require('@/assets/img/core-img/expedia.png') : review.ReviewSource == 'Google' ? require('@/assets/img/core-img/google.png') : review.ReviewSource == 'Holiday Check' ? require('@/assets/img/core-img/holidaycheck.png') : review.ReviewSource == 'Facebook' ? require('@/assets/img/core-img/facebook.png') : require('@/assets/img/core-img/agoda.png')" width="60px" alt="">
                                    </div>
                                </div>
                                <p class="pt-3" style="line-height: 1.5;">{{review.ReviewDetail}}</p>
                                <p class="mb-0"><small class="text-muted">{{review.ReviewDate}}</small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ##### Reviews Area End ##### -->

    </div>
</template>
<script>
import {_} from 'vue-underscore';
import moment from 'moment';
export default {
    name: 'reviews',
    data: ()=>({
        reviewList: null
    }),
    metaInfo: {
        title: 'Malahini Kuda Bandos - Reviews',
        meta: [
            { charset: 'utf-8' },
            { name: "description", content: "Malahini Kuda Bandos guest reviews" },
            { name: "keywords", content: "Malahini,Kuda Bandos,reviews" }
        ]
    },
    mounted() {
        this.$http.get('https://www.malahini.mv:9443/web/api/review').then((response)=>{
            let reviews = _.where(response.data, {ShowOnReviews: true}); // Get the sorted results
            this.reviewList = reviews.reverse()
            for (let r of this.reviewList) {
                r.ReviewDate = moment(r.ReviewDate).format('DD MMMM YYYY')
            }
        })
    }
    
}
</script>